import React from 'react';
import Header from './Header';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';

const PageLayout = ({ onDateChange, setLoading }) => {
  return (
    <div className='h-[90%] mx-auto'>
      <Header onDateChange={onDateChange} setLoading={setLoading} />
      <main className='main-content'>
        <Outlet context={{ setLoading }} /> {/* Outlet에 context로 setLoading 전달 */}
      </main>
      <Footer />
    </div>
  );
};

export default PageLayout;
